export const env = {
  URL_SERVER_BACKEND: process.env.URL_SERVER_BACKEND,
  URL_SOFTSEGUROS: process.env.URL_SOFTSEGUROS,
  URL_VEHICLE_DATA_SERVICE: process.env.URL_VEHICLE_DATA_SERVICE,
  FLAGSMITH_API_URL: process.env.FLAGSMITH_API_URL,
  FLAGSMITH_ENVIRONMENT_ID: process.env.FLAGSMITH_ENVIRONMENT_ID,
}